<template>
    <div id="calendar-schedule" class="calendar-schedule"><!-- orderedByDay filtered -->
        <CalendarListing 
            :itemsByDate="itineraryByDate"
            :timezone="timezone"
            :me="me"
            @modal="doModal"
        />

        <!--
        <div v-for="(day, index) in itineraryByDate" :key="index"
            class="calendar-schedule-day"
        >
            <div class="calendar-schedule-date">
                {{asDateOnly(day[0].end_time_utc, timezone)}}
            </div>

            <div class="calendar-schedule-day-list">
                <CalendarItem v-for="(item, iIndex) in day" 
                    :key="index+'-'+iIndex" 
                    :item="item"
                    :timezone="timezone"
                    @click="doModal(item)"
                >
                    <CalendarIcon :item="item" :me="me" />
                    <div class="calendar-item-meta">
                        <CalendarItemTime :item="item" :timezone="timezone" />
                        <CalendarItemLocation 
                            v-if="!isLocationLong(item)"
                            :item="item" />
                    </div>
                    <div class="calendar-schedule-detail">
                        <CalendarItemDetails :item="item" />

                        <h5 v-if="item.colleagues && item.colleagues.length"
                            class=""
                        >Also attending</h5>
                        <ProfileWidget v-for="colleague in item.colleagues" :key="colleague.id"
                            class="col-both"
                            
                            :title="colleague.full_name"
                            :subtitle="colleague.organisation_name"
                            :rows="1"
                        />
                        < !-- :id="colleague.attendee_id" -- >
                        <CalendarItemLocation 
                            v-if="isLocationLong(item)"
                            :item="item" />
                    </div>

                </CalendarItem>
            </div>
        </div>
        < !-- filtered - ->
        <div v-if="Object.keys(itineraryByDate).length == 0"
            class="calendar-schedule-empty"
        >
            <span>ITINERARY EMPTY</span>
        </div>
        -->
    </div>
</template>

<script>
/** Iterate through the list inserting LOCAL day boundaries as required.
 */
// import ProfileWidget from "@/components/ProfileWidget";

// import CalendarIcon from "@/views/calendar/CalendarIcon";
// import CalendarItem from "@/views/calendar/CalendarItem";
// import CalendarItemDetails from "@/views/calendar/CalendarItemDetails";
// import CalendarItemLocation from "@/views/calendar/CalendarItemLocation";
// import CalendarItemTime from "@/views/calendar/CalendarItemTime";

// import {asDateOnly} from '@/utils/DateTime';

import CalendarListing from "@/views/calendar/CalendarListing";
// import {isInSchedule} from "@/utils/Filter";
// import {groupByDate} from '@/utils/Sort';

// If the location is longer than this length, we display it under the content.
// const lenLocationMax = 30;


export default {
    name: "CalendarSchedule",
    props: {
        items: {
            type: Array,
            required: true,
        },
        itemsByDate: {
            type: Object,
            required: true,
        },
        privatesByDate: {
            type: Object,
            required: true,
        },
        busySlotIds: {
            type: Set,
            required: true,
        },
        itineraryByDate: {
            type: Object,
            required: true,
        },
        pageDate: {
            type: String,
            required: true,
        },
        eventDates: {
            type: Array,
            required: true,
        },
        activeDates: {
            type: Array,
            required: true,
        },
        itineraryDates: {
            type: Array,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        timezone: {
            type: String,
            required: true,
        },
        filters: {
            type: Object,
            required: true,
        },
        toggles: {
            type: Object,
            required: true,
        },
        slots: {
            type: Array,
            required: false,
        },
        tracks: {
            type: Array,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        }
    },
    components: {
        // CalendarIcon,
        // CalendarItem,
        // CalendarItemDetails,
        // CalendarItemLocation,
        // CalendarItemTime,
        // ProfileWidget,
        CalendarListing,
    },
    computed: {
    },
    methods: {
        // asDateOnly,
        doModal(item) {
            this.$emit('modal', {
                item: item,
                items: this.items
            });
        },
        // isLocationLong(item) {
        //     if (item.location) {
        //         return (item.location.length > lenLocationMax);
        //     }
        //     return (item.meeting_point_name && (item.meeting_point_name.length > lenLocationMax));
        // },

    }
}
</script>

<style>
.calendar-schedule-day {
    /* border-top: 2px solid #ccc; */
    border-top: none;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding-top:5px;
}

.calendar-schedule-day .calendar-schedule-date {
    position: static;
    font-weight: bold;
    padding: 5px 20px 5px 5px;
    min-width: 60px;
    border-bottom: 2px solid #ccc;
}
.calendar-schedule-day-list {
    flex-grow: 1;
}

/* CalendarItem customisation! */
#calendar-schedule .calendar-item {
    padding: 5px;
    flex: 1 1 auto;
    gap: 10px;
    border-bottom: 1px solid #ccc;
}
#calendar-schedule .calendar-item:last-child {
    border-bottom: none;
}

#calendar-schedule .calendar-icon {
    width: 16px;
    min-width: 16px;
}
#calendar-schedule .calendar-item-meta {
    width: 200px;
    max-width: 200px;
    min-width: 200px;
}
#calendar-schedule .calendar-item-title {
    font-weight: bold;
}

#calendar-schedule .calendar-item-organisation-name {
    font-style: italic;
}

#calendar-schedule .calendar-schedule-status {
    margin: 0 10px 0 0;
}

#calendar-schedule .track-hidden {
    background-color: #333;
    color: #eee;
}
#calendar-schedule h5 {
    margin-bottom: 0;
}

/* Alternate position for long location/point content */
.calendar-schedule-detail .calendar-item-location {
  border-top: 1px solid #eee;
  margin-top: 5px;
  padding-top: 5px;
}

.calendar-schedule-empty {
    background-color: #ccc;
    display: grid;
    align-content: center;
    justify-content: center;
    margin-top: 30px;
    padding: 10px;
}
.calendar-schedule-empty span {
    color: #fff;
    font-weight: bold;
}

@media print {
    #calendar-schedule .track-hidden {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        background-color: #ddd;
        color: #000;
    }
}

@media screen and (max-width: 400px) {
    #calendar-schedule .calendar-item-meta {
        width: 100px;
        max-width: 100px;
        min-width: 100px;
    }
}

</style>